<script>
import { SubscriptionCardElementMixin } from "%/dynamic-component-editor/standard-components/subscription-card/subscription-card-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

const EXAMPLE_NOTE = "Auto-renew is off. Your Pro Monthly plan ends in 3 days. You will move to Free Plan after that.";

export default {
  name: "SubscriptionPlanNote",
  elementPanelSettings: {
    tags: ["cancelled", "renewal", "billing", "notice"],
    displayName: "Plan Note",
    displayIcon: "text-alt",
    elementGroup: "subscriptionElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [SubscriptionCardElementMixin],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      if (this.editMode) {
        return EXAMPLE_NOTE;
      }
      if (!this.isCurrentPlan) {
        return "";
      }
      const note = window.blclient?.data?.subscriptionNote;
      return note ? note : "";
    },
  },
};
</script>
